<template>
  <div class="course-content">
    <div class="course-boxs">
      <div class="course-menu">
        <!-- 顶级分类 -->
        <!-- <div class="course-class">
          <div class="name">课程详情：</div>
          <span :class="course_type==0?'active':''" @click="getTabList(0)">视频课程</span>
        </div> -->
        <!-- 一级分类 -->
        <div class="course-class" v-if="course_type==0">
          <div class="name">课程分类：</div>
          <div class="list">
            <div
              class="courname"
              v-for="(item,index) in ress"
              :key="item.id"
              :class="{active: one_flag== index?'active':'',lefts:index== 8 || index == 15 ||index==22 || index == 29 ? 'lefts': '',centter: index ==0}"
              @click="toGetMubList(item.id,index)"
            >{{item.title}}</div>
          </div>
        </div>
        <!-- <div class="course-class" v-if="course_type==1">
          <div class="name">班级列表：</div>
          <span
            v-for="(items,indexs) in ress"
            :key="items.id"
            :class="one_flags == indexs?'active':''"
            @click="toGetClassCourse(items.id,indexs)"
          >{{items.name}}</span>
        </div> -->
        <!-- 二级分类 -->
        <div class="course-class" v-if="course_type==0 && secondMenu && secondMenu != 'undefined'">
          <div class="name"> 二级分类：</div>
          <span
            v-for="(items,index) in secondMenus"
            :key="items.id"
            :class="two_flag== index?'active':''"
            @click="toGetSubList(items.id,index)"
          >{{items.title}}</span>
        </div>
      </div>
    </div>
    <div class="container">
      <a-row :gutter="20" v-if="course_type==0">
        <a-col
          :span="6"
          class="course-box"
          v-for="item in videoCourseList"
          :key="item.id"
          @click="toDetails(item.id,course_type==0 ? 0:1)"
        >
          <div class="card">
            <CourseCard :item="item" />
          </div>
        </a-col>
        <a-col v-show="showCourse">
          <div class="noData">暂无数据</div>
        </a-col>
      </a-row>
      <a-row :gutter="20" v-if="course_type==1">
        <a-col
          :span="6"
          class="course-box"
          v-for="item in liveCourseList"
          :key="item.id"
          @click="toDetails(item.id,course_type==0 ? 0:1)"
        >
          <div class="card">
            <CourseCard :item="item" />
          </div>
        </a-col>
        <a-col v-show="showCourse">
          <div class="noData">暂无数据</div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>
<script>
import CourseCard from "./components/CourseCard.vue";
import { getCookie, group_sign } from '../../utils/tool'
import { mapState } from "vuex";
export default {
  name: "course",
  components: {
    CourseCard
  },
  data() {
    return {
      videoCourseList: [],
      liveCourseList: [],
      res: [],
      resClass: {},
      kind_level: null,
      course_type: 0,
      one_flag: 0,
      one_flags: 0,
      mub_id: "",
      two_flag: 0,
      account_id:Number(getCookie('account_id')),
      secondMenu: [],
      showCourse: false
    };
  },
  computed: {
    ...mapState(["isLogin"]),
    ress: function() {
      return this.sortKey(this.res,'order_num')
    },
    secondMenus: function() {
      return this.sortKey(this.secondMenu,'order_num')
    }
  },
  methods: {
    sortKey(arr, key){
      return arr.sort(function(a, b){
        var x = a[key];
        var y = b[key];
        return ((x<y)?-1:(x>y)?1:0)
      })
    },
    toGetClassCourse(id, index){
      this.one_flags = index;
      let that = this;
      var param = group_sign({account_id:this.account_id,class_id: id});
      this.$axios.post(this.$Api.apiGetClassCourseList, param).then(
        res => {
          this.liveCourseList = res.data.result.classInfo.courseList
          if (this.liveCourseList.length>0) {
            this.showCourse = false
          } else {
            this.showCourse =true
          }
        }
      )
    },
    getCourseList(kind_level) {
      var param = group_sign({category_id:kind_level, number: 999});
      this.$axios.post(this.$Api.apiGetCourseList,param).then(res => {
        this.videoCourseList = res.data.result.list
        if (this.videoCourseList.length>0) {
          this.showCourse = false
        } else {
          this.showCourse =true
        }
      }).catch(error => {console.log(error, ">>>>>>>>>");});
    },
    // 课程分类
    getVideoKind() {
      var param = group_sign()
      this.$axios.post(this.$Api.apiGetClassifyList, param).then(
        sccesss => {
          let res = sccesss.data.result.list;
          if (res) {
            res.unshift({
                title: "全部",
                id: 0,
                children: [],
                order_num: 1
            })
          }
          for(let index = 0; index<res.length; index++) {
            if (res[index].children) {
              res[index].children.unshift({
                title: "全部",
                id: res[index].id,
              });
            }
          }
          this.res = res;
          this.secondMenu = this.res[0].children
          if (this.secondMenu) {
            this.getCourseList(this.secondMenu[0].id);
          } else {
            this.getCourseList(this.res[0].id)
          }
          
        }
      ).catch(error => {console.log(error, ">>>>>>>>>"); });
    },
    getLiveKind() {
      let that = this;
      var param = group_sign({account_id: that.account_id,top_category_id: that.topId,visible: 1})
      this.$axios.post(this.$Api.apiGetClassList, param).then(
        res => {
          that.res = res.data.result.list;
          this.toGetClassCourse(that.res[0].id)
          that.one_flags = 0
        }
      ).catch(error => {console.log(error, ">>>>>>>>>");});
    },
    getTabList(id) {
      this.course_type = id;
      this.one_flag = 0;
      this.mub_id = "";
      this.two_flag = 0;
      let kind_level = this.kind_level,
        course_type = id,
        main_id = "",
        sub_id = "";
      if (id == 0) {
        this.getVideoKind();
        this.getCourseList(kind_level, course_type, main_id, sub_id);
      } else if (id == 1) {
        this.one_flags = 0
        this.getLiveKind();  
      }
    },
    toGetMubList(id, index) {
      for (let i in this.res) {
        if (this.res[i].id == id) {
          this.secondMenu = this.res[i].children
        }
      }
      this.one_flag = index;
      if (this.secondMenu) {
        this.getCourseList(this.secondMenu[0].id)
      } else {
        this.getCourseList(id)
        // debugger
      }
      this.two_flag = 0;
    },
    toGetSubList(id, index) {
      this.two_flag = index;
      this.getCourseList(id)
    },
    toDetails(id, type) {
      // if (this.isLogin) {
        this.$router.push({
        path: "/page/course_details",
        query: { course_id: id, course_type: type }
      });
      // } else {
      //   this.$root.Bus.$emit("showLogin")
      // }
    }
  },
  beforeMount() {
    this.getVideoKind();
  }
};
</script>
<style lang="less" scoped>
@import url('../../assets/less/course.less');
</style>
